import { EnvSchema } from '#schema/EnvSchema';

export const env = EnvSchema.parse({
  baseUrl: import.meta.env.VITE_BASE_URL,
  strictMode: import.meta.env.VITE_IS_STRICT_MODE === 'true',
  appName: import.meta.env.VITE_APP_NAME,
  auth: {
    clientId: import.meta.env.VITE_APP_CLIENT_ID,
    tenantId: import.meta.env.VITE_APP_TENANT_ID,
    cluster: import.meta.env.VITE_APP_CLUSTER,
    project: import.meta.env.VITE_APP_PROJECT,
    redirectUri: import.meta.env.VITE_APP_REDIRECT_URI,
  },
  cdf: { url: import.meta.env.VITE_APP_CDF_URL },
  dataModelSpace: import.meta.env.VITE_APP_DATA_MODEL_SPACE,
  dataInstanceSpace: import.meta.env.VITE_APP_DATA_INSTANCE_SPACE,
  dataModelVersion: import.meta.env.VITE_APP_DATA_MODEL_VERSION,
  dataModelExternalId: import.meta.env.VITE_APP_DATA_MODEL_EXTERNAL_ID,
});
